export default __webpack_public_path__ + "media/images/fonts/Flaticon-f283a33e831cd766ee5035a1ce09eea4.svg";